export const DEFAULT_MESSAGE = "Please sign this message"
export const DEFAULT_SIGN_LOADING_TEXT = "Check your wallet"
